// @ts-nocheck

import palette from '../palette';

export const SeeLineUpButton = {
  backgroundColor: palette.bluegrey850,
};

export const LineUpPlayerGoalMultiplicator = {
  color: palette.yellowwinamax300,
  ownGoalColor: palette.red100,
  backgroundColor: palette.bluegrey900,
};

export const LineUpPlayerStats = {
  default: {
    backgroundColor: palette.yellowwinamax850,
    color: palette.yellowwinamax350,
  },
  ended: {
    backgroundColor: palette.black,
    color: palette.white,
  },
};

export const LineUpRacerStats = {
  default: {
    backgroundColor: 'rgba(255, 191, 0, 0.15)',
    color: palette.yellowwinamax350,
  },
  out: {
    backgroundColor: 'rgba(102, 115, 153, 0.5)',
    color: palette.bluegrey200,
  },
  ended: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    color: palette.white,
  },
};

export const LineUpPitStop = {
  default: {
    fillColor: palette.yellowwinamax500,
    fillOpacity: 0.5,
    color: palette.yellowwinamax500,
  },
  ended: {
    fillColor: palette.white,
    fillOpacity: 0.5,
    color: palette.white,
  },
};

export const LineUpPlayerSubtitutionInfosArea = {
  color: palette.bluegrey200,
};

export const LineUpField = {
  infoBackgroundColor: 'rgba(20, 23, 31, 0.7)',
};

export const LineUpMainViewScrollbar = {
  thumbColor: palette.bluegrey900,
};

export const LineUpPlayeCardIcon = {
  default: {
    backgroundColor: palette.bluegrey900,
    backgroundGradient1: palette.bluegrey950,
    backgroundGradient2: '#211F2E',
    detailsBackgroundColor: palette.bluegrey800,
    lightColor: palette.bluegrey750,
    lighterColor: palette.bluegrey650,
    selectedBorderColor: palette.redwinamax500,
  },
};

export const LineUpSlider = {
  infoBackgroundColor: 'rgba(255, 255, 255, 0.1)',
};

export const LineUpMatchHeader = {
  backgroundColor: '#21263b',
  darkBackground: palette.bluegrey900,
  defaultTransparentBackground: 'rgba(255, 255, 255, 0.1)',
  darkHeaderBackground: palette.bluegrey850,
  transparentHeaderBackground: 'rgba(255, 255, 255, 0.05)',
  selected: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
};
